import {classify,followingDraws} from './analysis';
import {MODEL} from './localPrediction';
export const SIX_FIELDS=[['size','大小',['大','小']],['parity','单双',['单','双']],['family','家禽 / 野兽',['家','野']]];
export const sixLabel=value=>value==='家'?'家禽':value==='野'?'野兽':value;
export function sixPrediction(history) {
  const sample=history.slice(0,100),following=followingDraws(sample,'six');
  const gap=sample.some((draw,i)=>i>0&&Number(sample[i-1].issue)-Number(draw.issue)!==1);
  const fields=SIX_FIELDS.map(([id,label,values])=>{
    const count=draws=>values.map(value=>draws.filter(draw=>classify(draw,'six',id)===value).length);
    const base=count(sample),next=count(following),baseTotal=base[0]+base[1],total=next[0]+next[1];
    const mode=!baseTotal?'default':!gap&&total>=MODEL.minConditional?'smoothed':'baseline';
    const scores=values.map((value,i)=>({value,score:mode==='smoothed'?(next[i]+MODEL.weight*(base[i]+1)/(baseTotal+2))/(total+MODEL.weight):(base[i]+1)/(baseTotal+2)}));
    scores.sort((a,b)=>b.score-a.score);
    return {id,label,value:scores[0].value,baseTotal,total,mode,scores};
  });
  return {version:'six-attributes-100-v1',fields,baseTotal:sample.length,total:following.length,mode:fields.every(field=>field.mode==='default')?'default':'statistics',conditionIssue:sample[0]?.issue};
}
